import React, {useState, useEffect, useContext} from 'react'
import { CdnImage, CdnPath } from '../../../shared/cdn-image'
import Loader from '../../../shared/loader'
import { navigate, useLocation } from "@reach/router"
import AccommodationMap from '../accommodation/accommodation-map'
import QuoteContext from "../../quote-context";
import axios from 'axios'

const Accommodation = ({ destination, accommodation, selectedHotel, allowPick, allowedFilters, processForm }) => {

	const location = useLocation();
	const {navigation, navigationDispatcher, formData, formDispatcher} = useContext(QuoteContext);

	const[mapView, setMapView] = useState(false);
	const[activeFilter, setActiveFilter] = useState(0);
	const[loading, setLoading] = useState(false);
	const[items, setItems] = useState([]);
	const[ cheapestHotel, setCheapestHotel ] = useState(0)

	const isAddingPackage = navigation.step.params != null && typeof navigation.step.params.isPackage !== "undefined" && navigation.step.params.isPackage ? true : false
	
	useEffect(()=>{
		getCheapestHotel()
	},[])

	const getCheapestHotel = async() => {

		const postData = new FormData();
		postData.append( 'locationId', navigation.destination.id );
		postData.append( 'date', formData.date );
		postData.append( 'pax', formData.pax );

        await axios.post('/quote/v2/hotel', postData )
        .then(({data}) =>{
            if( data.hotels.length > 0 ) {
				setCheapestHotel( data.hotels[0] )
			}
        })
		.catch(function(error) {
			//not important if this fails
			return false
		});
    }

	useEffect(()=>{
		let newItems = accommodation.filter( hotel => activeFilter == 0 || hotel.ratingAdj == activeFilter);
		setItems(newItems);
	},[activeFilter])

	const viewHotel = (hotel) => {

		navigationDispatcher({
			type: 'OPEN_MODAL',
			modal: './quote/modal/named-hotel',
			title: hotel.name,
			reviewScore: hotel.reviewScore,
			payload: {
				siteId: navigation.siteId,
				locationId: navigation.destination.id,
				id: hotel.id,
				reviewScore: hotel.reviewScore,
				showAll: false,
				day: typeof location.state.day !== "undefined" ? parseInt(location.state.day) : 1,
				selected: typeof selectedHotel !== "undefined" && selectedHotel.id == hotel.id,
				hasButton: true,
				addHotel: ( selectedHotel ) => {
					
					formDispatcher({type:"ADD_HOTEL", hotel: selectedHotel});
					
					if( isAddingPackage && formData.activities.length > 0 ) {
						if( navigation.loggedIn ) {
							//TODO: process form
							navigationDispatcher({ type: "GOTO_STEP", step: "itinerary", params: null});
						} else {
							navigationDispatcher({ type: "GOTO_STEP", step: "submit", params: null});
						}
					} else {
						navigationDispatcher({ type: "GOTO_STEP", step: "itinerary", params: null});
					}
					
					
					navigationDispatcher({
						type: 'TRACK_EVENT',
						action: 'event',
						category: 'click',
						name: 'add-named-hotel',
						trigger: 'web-js',
						data: {
							day: selectedHotel.day,
							id: selectedHotel.id,
							name: selectedHotel.name,
							nights: selectedHotel.nights,
							reviewScore: selectedHotel.reviewScore
						}
					});
					
				}
			}
		})

		/*
		navigationDispatcher( { type: 'OPEN_MODAL', modal: 'NamedHotelInfo', title: hotel.name, payload: {
			id: hotel.id,
			type: 'hotel',
			selected: typeof selectedHotel !== "undefined" && selectedHotel.id == hotel.id,
			day: typeof location.state.day !== "undefined" ? parseInt(location.state.day) : 1
		}});
		*/

		navigationDispatcher({
			type: 'TRACK_EVENT',
			action: 'event',
			category: 'click',
			name: 'view-named-hotels',
			trigger: 'web-js',
			data: {
				id: hotel.id,
				name: hotel.name,
				reviewScore: hotel.reviewScore
			}
		});

	}

	return (
		<div>
			<div className="full-width-block white pd-v">
				<div className="row">
					<div className="column">
						<h2 className="mg-v">{ isAddingPackage ? 'Do you require accommodation?' : 'Add accommodation' }</h2>
					</div>
				</div>		
			</div>

			<div className="full-width-block">
				<div className="row no-padding">
					<div className="column">
						<div className="pd-h-dsk-md">
							<div className="content-block shadow-dsk radius">
								<div className="pd-dsk-md">
									<div className="full-width-block">
										<div className="row no-padding full-width">
											<div className="pd-h-tch pd-h-dsk-md">
												<div className="align-content vertical center split-mob tabs scrollable">
													<div className={`tab mg-r-dsk-lrg mg-r-tch` + ( activeFilter == 0 ? ` active` : null )}><a className="link black pointer" onClick={() => setActiveFilter(0)}>Show all</a></div>
													{allowedFilters.map( (filter) =>
														<div key={`standard-filter-` + filter} onClick={() => setActiveFilter(filter)} className={`tab mg-r-dsk-lrg mg-r-tch` + ( activeFilter == filter ? ` active` : '')}>
															<p>{Array(filter +1).join("£")}</p>
														</div>
													)}
												</div>
											</div>
										</div>		
									</div>

									<div className="full-width-block">
										<div className="row no-padding full-width">
											<div className="pd-h-tch pd-h-dsk-md">
												<div className="align-content vertical center wrap-mobile split">
													<button className="button secondary fit-content center inverted radius mg-v" onClick={() => setMapView(!mapView)}><span className="icon icon-directions large secondary left"></span><p className="secondary nowrap">{mapView ? `List view` : `Map view`}</p></button>

													{allowPick ? 
													<div className="align-content vertical center horizontal right show-for-large">
														<p className="pd-r bold">Other options:</p>
														<button className="button secondary fit-content center radius mg-v-dsk" onClick={() => navigationDispatcher({ type: "GOTO_STEP", step: "accommodationTypes", params: { day: location.state.day, isPackage: false }})}>Choose for me<span className="icon icon-chevron-bold-right white small right"></span></button>
													</div>
													 : null }
												</div>
											</div>
										</div>		
									</div>

									{ loading ? (
										<Loader />
									) : (
									<div>
										{mapView ? (
											<AccommodationMap
												items={items}
												siteId={navigation.siteId}
												destination={destination}
												selectedHotel={selectedHotel}
												viewHotel={viewHotel}
											/>
										) : (
											<>
												<div className="full-width-block">
													<div className="row no-padding full-width">
														<div className="pd-h-tch pd-h-dsk-md">
															<div className="align-content grid wrap">
																{items.map( accom =>
																	<div key={`accom-` + accom.id} className="grid-item one-quarter mg-b">
																		<a onClick={() => viewHotel(accom)} className="modal-toggle">
																			
																			<div className={selectedHotel != false && selectedHotel.id == accom.id ? `full-width height-200 selected` : `full-width height-200`} style={navigation.siteId == 1 ? {marginBottom: "1rem", backgroundSize: 'cover', backgroundImage: `url("${CdnPath( navigation.siteId, accom.image.name, accom.image.path, false, false, false, false )}")`, borderRadius: "0.3rem"} : {marginBottom: "0", backgroundSize: 'cover', backgroundImage: `url("${CdnPath( navigation.siteId, accom.image.name, accom.image.path, false, false, false, false )}")`, borderTopLeftRadius: "0.5rem", borderTopRightRadius: "0.5rem"}}>
																				{cheapestHotel == accom.id && <span className="banner fill pd text-center top radius-t green">CHEAPEST FOR YOUR DATES!</span>}
																				<span className={cheapestHotel == accom.id ? `mg-t-lrg rating icon-` + accom.ratingAdj : `rating icon-` + accom.ratingAdj}></span>
																				{accom.featured &&
																					<div className={cheapestHotel == accom.id ? "banner-holder mg-t-md" : "banner-holder"}>
																						<div className="banner pill yellow bold">Best Seller</div>
																					</div>
																				}
																			</div>

																			<div className={navigation.siteId == 1 ? '' : 'bg-light-grey pd radius-b-lrg'}>
																				<p className="text-medium bold">{accom.name}</p>
																				{accom.reviewScore != 0 ?
																					<div className="align-content vertical center">
																						<div className="stars mg-v-sm mg-r-sm" style={{'--rating': accom.reviewScore}}></div>
																						<span className="show-for-large">View reviews</span>
																					</div>
																				: null }
																			</div>
																		</a>
																	</div>
																)}
															</div>
														</div>
													</div>
												</div>
											</>
										)}
									</div>		
									)}
								</div>
							</div>
							</div>
							{ allowPick ? 
								<div className="full-width-block hide-for-large">
									<div className="row no-padding">
										<div className="pd-h-tch pd-h-dsk-md">
											<div className="pd-v border-v">
												<div className="align-content vertical horizontal center">
													<p className="pd-r bold">Other options:</p>
													<button className="button secondary fit-content center radius" onClick={() => navigationDispatcher({ type: "GOTO_STEP", step: "accommodationTypes", params: { day: location.state.day, isPackage: false }})}>Choose for me<span className="icon icon-chevron-bold-right white small right"></span></button>
												</div>
											</div>
										</div>
									</div>
								</div>
							: null }
						<div className="full-width-block white pd-v">
							<div className="row no-padding">
								<div className="column">
									<div className="pd-h-tch pd-h-dsk-md">
										{isAddingPackage ? (
											<button
												className="button secondary radius" 
												onClick={() => {
													if( navigation.loggedIn ) {
														//TODO: PROCESS FORM
														//processForm();
														navigationDispatcher({ type: "GOTO_STEP", step: "itinerary", params: null});
													} else {
														formDispatcher({type: "RESET_HOTEL" });
														navigationDispatcher({type: "GOTO_STEP", step: "submit", params: { isPackage: true } });
													}
												}}
											>
												No Accommodation required 
												<span className="icon icon-chevron-right white small right"></span>
											</button>	
										) : (
											<button 
												className="button secondary radius" 
												onClick={() => {navigate('./')}}
											>
												<span className="icon icon-chevron-left white small left"></span> Back
											</button>
										)}
									</div>
								</div>
							</div>		
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Accommodation;
